/* eslint-disable global-require */
import React, { useContext } from 'react'

// types
import { MapPointsResponse } from '../../types/types'

// utils
import { AppContext } from '../../utils/appProvider'

// styles
import * as SC from './SalonImageStyles'

type Props = {
	salon: MapPointsResponse['mapPoints'][number]['salon']
	width?: number
	height?: number
	className?: string
	loading?: React.ImgHTMLAttributes<HTMLImageElement>['loading']
}

const SalonImage = ({ salon, className, loading, width, height }: Props) => {
	const { assetsPath } = useContext(AppContext)
	const imageSmallSrc = salon.images[0]?.resizedImages.small
	const imageSrc = imageSmallSrc || `${assetsPath}/${require('../../assets/images/basic-salon-placeholder-small.jpg')}`
	const imageSrcWebP = imageSmallSrc ? undefined : `${assetsPath}/${require('../../assets/images/basic-salon-placeholder-small.webp')}`

	const salonImage = <SC.SalonImage src={imageSrc} alt={''} loading={loading} className={className} width={width} height={height} />

	if (imageSrcWebP) {
		return (
			<picture>
				<source srcSet={imageSrcWebP} type='image/webp' />
				{salonImage}
			</picture>
		)
	}

	return salonImage
}

export default SalonImage
